import {
    Component,
    ElementRef,
    EventEmitter,
    HostListener,
    Input,
    OnInit,
    Output,
    ViewChild,
} from '@angular/core';
import { fadeInOut } from '@helpers/fadeInOut';

export interface Options {
    label: string;
    value: string;
    isActive?: boolean;
}

@Component({
    selector: 'app-search-dropdown',
    templateUrl: './search-dropdown.component.html',
    styleUrls: ['./search-dropdown.component.css'],
    animations: [fadeInOut],
    standalone: false
})
export class SearchDropdownComponent implements OnInit {
    public isDropDownOpen: boolean = false;
    public keyword = '';
    public filteredOptions: Options[];

    @Input() options: Options[];

    @Output() setSearchEvent = new EventEmitter<any>();

    @Input() label: string = '';

    @HostListener('document:click', ['$event'])
    clickOut(event: any) {
        if (!this.eRef.nativeElement.contains(event.target)) {
            this.isDropDownOpen = false;
        }
    }

    @ViewChild('searchDropdownOption', { static: true }) searchDropdownOption;

    constructor(private eRef: ElementRef) {}

    ngOnInit() {
        this.filteredOptions = this.options;
    }

    public searchKeyword(evt) {
        this.isDropDownOpen = true;
        if (evt === '') {
            this.filteredOptions = this.options;
        } else {
            this.filteredOptions = this.options.filter((option) => option.value.includes(evt));
        }
    }

    public startTyping() {
        this.isDropDownOpen = true;
    }

    public remove() {
        this.keyword = '';
        this.filteredOptions = this.options;
    }

    public selectOption(value: string) {
        this.keyword = value;
        this.isDropDownOpen = !this.isDropDownOpen;
    }

    public setSearchEventTrigger() {
        this.setSearchEvent.emit(this.keyword);
    }
}
